import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import { setuserinfo } from '../nurseshift';
import mixpanelConstants from '../../constants/mixpanel';

export const setAccountErrors = createAction('SET_SUPERVISOR_ACCOUNT_ERRORS');
export const setSupAccountDetails = createAction('SET_SUP_ACCOUNT_DETAILS');
export const setAccountDisplay = createAction('SET_SUPERVISOR_ACCOUNT_DISPLAY');
export const setAccountMessage = createAction('SET_SUPERVISOR_ACCOUNT_MESSAGE');
export const setAccountFullName = createAction('SET_SUPERVISOR_ACCOUNT_FULL_NAME');
export const setAccountFirstName = createAction('SET_SUPERVISOR_ACCOUNT_FIRST_NAME');
export const setAccountLastName = createAction('SET_SUPERVISOR_ACCOUNT_LAST_NAME');
export const setAccountEmail = createAction('SET_SUPERVISOR_ACCOUNT_EMAIL');
export const setAccountAddres = createAction('SET_SUPERVISOR_ACCOUNT_ADDRESS');
export const setAccountAddress2 = createAction('SET_SUPERVISOR_ACCOUNT_ADDRESS_2');
export const setAccountCity = createAction('SET_SUPERVISOR_ACCOUNT_CITY');
export const setAccountState = createAction('SET_SUPERVISOR_ACCOUNT_STATE');
export const setAccountZipcode = createAction('SET_SUPERVISOR_ACCOUNT_ZIPCODE');
export const setAccountPrimaryPhone = createAction('SET_SUPERVISOR_ACCOUNT_PRIMARY_PHONE');
export const setAccountAlternatePhone = createAction('SET_SUPERVISOR_ACCOUNT_ALTERNATE_PHONE');
export const setProfileStatus = createAction('SET_SUPERVISOR_PROFILE_STATUS');
export const setProfilePreview = createAction('SET_SUPERVISOR_PROFILE_PREVIEW');
export const setProfileFileType = createAction('SET_SUPERVISOR_PROFILE_FILE_TYPE');
export const setProfileUserID = createAction('SET_SUPERVISOR_USER_ID');
export const setReviewUnderProcessRedirPath = createAction('SET_REVIEW_UNDER_PROCESS_REDIR_PATH');
export const setIncompletedRedirPath = createAction('SET_INCOMPLETED_REDIR_PATH');
export const setAccoountAccessDenied = createAction('SET_SUPERVISOR_ACCOUNT_ACCESS_DENIED');
export const setBackBtnClicked = createAction('SET_BACK_BTN_CLICKED');

export const setAccountOldPassword = createAction('SET_SUPERVISOR_ACCOUNT_OLD_PASSWORD');
export const setAccountNewPassword = createAction('SET_SUPERVISOR_ACCOUNT_NEW_PASSWORD');
export const setAccountConfirmPassword = createAction('SET_SUPERVISOR_ACCOUNT_CONFIRM_PASSWORD');
export const clearProfilepic = createAction('CLEAR_USERPROFILEPIC');
export const setSupervisorOrgs = createAction('SET_SUPERVISOR_ORGS');
export const resetAccount = createAction('REST_SUPERVISOR_ACCOUNT');

export const setShowSuperNotiPref = createAction('SET_SUPER_SHOW_NOTI_PREF');
export const setPasswrdToViewPin = createAction('SET_PASSWORD_TO_VIEWPIN');
export const setCurrentPinCode = createAction('SET_CURRENT_PINCODE');
export const setNewPinCode = createAction('SET_NEW_PINCODE');
export const setSecurity_code = createAction('SET_SECURITY_CODE');
export const setShowConfirmPinPopup = createAction('SET_SHOW_CONFIRM_PINPOPUP');

export const setShowSupervisorHelpDialog = createAction('SET_SUPER_SHOW_HELP');

const initialState = {
	address: '',
	address2: '',
	alternatePhoneNumber: '',
	city: '',
	confirmPassword: '',
	currentPinCode: '',
	display: 'none',
	email: '',
	errors: {},
	firstName: '',
	fullName: '',
	lastName: '',
	message: '',
	newPassword: '',
	newPinCode: '',
	oldPassword: '',
	passwrdToViewPin: '',
	primaryPhoneNumber: '',
	profileImageFileType: '',
	profileImagePreview: '',
	security_code: 0,
	showConfirmPinPopup: false,
	showSuperHelpDialog: false,
	showSuperNotificationPref: false,
	state: '',
	status: '',
	user_id: '',
	user_orgs: [],

	zipcode: ''
};

export default handleActions(
	{
		CLEAR_USERPROFILEPIC: (state) => ({
			...state,
			profileImagePreview: initialState.profileImagePreview
		}),
		REST_SUPERVISOR_ACCOUNT: () => initialState,
		SET_CURRENT_PINCODE: (state, action) => ({
			...state,
			currentPinCode: action.payload
		}),
		SET_NEW_PINCODE: (state, action) => ({
			...state,
			newPinCode: action.payload
		}),
		SET_PASSWORD_TO_VIEWPIN: (state, action) => ({
			...state,
			passwrdToViewPin: action.payload
		}),
		SET_SECURITY_CODE: (state, action) => ({
			...state,
			security_code: action.payload
		}),
		SET_SHOW_CONFIRM_PINPOPUP: (state, action) => ({
			...state,
			showConfirmPinPopup: action.payload
		}),
		SET_SUP_ACCOUNT_DETAILS: (state, action) => ({
			...state,
			...action.payload
		}),
		SET_SUPER_SHOW_HELP: (state, action) => ({
			...state,
			showSuperHelpDialog: action.payload
		}),
		SET_SUPER_SHOW_NOTI_PREF: (state, action) => ({
			...state,
			showSuperNotificationPref: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_ADDRESS: (state, action) => ({
			...state,
			address: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_ADDRESS_2: (state, action) => ({
			...state,
			address2: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_ALTERNATE_PHONE: (state, action) => ({
			...state,
			alternatePhoneNumber: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_CITY: (state, action) => ({
			...state,
			city: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_CONFIRM_PASSWORD: (state, action) => ({
			...state,
			confirmPassword: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_DISPLAY: (state, action) => ({
			...state,
			display: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_EMAIL: (state, action) => ({
			...state,
			email: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_FIRST_NAME: (state, action) => ({
			...state,
			firstName: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_FULL_NAME: (state, action) => ({
			...state,
			fullName: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_LAST_NAME: (state, action) => ({
			...state,
			lastName: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_MESSAGE: (state, action) => ({
			...state,
			message: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_NEW_PASSWORD: (state, action) => ({
			...state,
			newPassword: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_OLD_PASSWORD: (state, action) => ({
			...state,
			oldPassword: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_PRIMARY_PHONE: (state, action) => ({
			...state,
			primaryPhoneNumber: action.payload
		}),

		SET_SUPERVISOR_ACCOUNT_STATE: (state, action) => ({
			...state,
			state: action.payload
		}),
		SET_SUPERVISOR_ACCOUNT_ZIPCODE: (state, action) => ({
			...state,
			zipcode: action.payload
		}),
		SET_SUPERVISOR_ORGS: (state, action) => ({
			...state,
			user_orgs: action.payload
		}),
		SET_SUPERVISOR_PROFILE_FILE_TYPE: (state, action) => ({
			...state,
			profileImageFileType: action.payload
		}),
		SET_SUPERVISOR_PROFILE_PREVIEW: (state, action) => ({
			...state,
			profileImagePreview: action.payload
		}),
		SET_SUPERVISOR_PROFILE_STATUS: (state, action) => ({
			...state,
			status: action.payload
		}),

		SET_SUPERVISOR_USER_ID: (state, action) => ({
			...state,
			user_id: action.payload
		})
	},
	initialState
);

export function trackAccountUpdate(userInfo) {
	mixpanel.track(mixpanelConstants.UPDATE_PERSONAL_DETAILS, {
		address: userInfo?.address,
		city: userInfo?.city,
		email: userInfo?.email,
		firstName: userInfo?.firstName,
		fullName: userInfo?.fullName,
		lastName: userInfo?.lastName,
		primaryPhoneNumber: userInfo?.primaryPhoneNumber,
		state: userInfo?.state,
		userId: userInfo?.user_id,
		zipcode: userInfo?.zipcode
	});
}

export const fetchAccountContact = () =>
	function (dispatch) {
		let userInfoAry = [];
		Agent.userContact().then((response) => {
			if (response.ok) {
				userInfoAry = response.data;
				dispatch(updateinfo(userInfoAry));
				dispatch(setuserinfo(userInfoAry));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const updateinfo = (info) =>
	function (dispatch) {
		dispatch(setProfileUserID(info.id));
		dispatch(setAccountFullName(info.fullname != null ? info.fullname : ''));
		dispatch(setAccountFirstName(info.first_name != null ? info.first_name : ''));
		dispatch(setAccountLastName(info.last_name != null ? info.last_name : ''));
		dispatch(setAccountEmail(info.email != null ? info.email : ''));
		dispatch(setAccountAddres(info.address != null ? info.address : ''));
		dispatch(setAccountAddress2(info.additional_address != null ? info.additional_address : ''));
		dispatch(setAccountCity(info.city != null ? info.city : ''));
		dispatch(setAccountState(info.state != null ? info.state : ''));
		dispatch(setAccountZipcode(info.zip != null ? info.zip : ''));
		dispatch(setAccountPrimaryPhone(info.phone != null ? info.phone : ''));
		dispatch(setAccountAlternatePhone(info.alt_phone != null ? info.alt_phone : ''));
		dispatch(setProfilePreview(info.photo_location != null ? info.photo_location : ''));
		dispatch(setProfileFileType(info.file_type != null ? info.file_type : ''));
		dispatch(setProfileStatus(info.status != null ? info.status : ''));
		dispatch(setSupervisorOrgs(info.user_orgs));
		dispatch(setSecurity_code(info.user_orgs[0].security_code));
	};

export const uploadProfileImage = (file) =>
	function (dispatch) {
		if (file) {
			dispatch(setAccountDisplay('block'));
			Agent.uploadFileOnS3(file).then((response) => {
				if (response.ok) {
					dispatch(setProfilePreview(response.data.path));
					dispatch(setProfileFileType(response.data.content_type));
				} else {
					alert('Failed to upload user image. Please check you file type and file size.');
				}
				dispatch(setAccountDisplay('none'));
			});
		}
	};

export const updateSecurityCode = (payload) =>
	function (dispatch, getState) {
		const { currentPinCode, newPinCode } = payload || {};
		const org_id = getState().nurseshift.info.user_orgs[0].organization_id;

		Agent.updateSecurityCode(org_id, parseInt(currentPinCode), parseInt(newPinCode)).then((response) => {
			if (response.ok) {
				dispatch(setShowConfirmPinPopup(true));
			} else {
				alert(response.data);
			}
		});
	};
